/**
 * 공종 관리 컬럼 정의
 * GON_BASIC 화면 전용
 * - 그리드1: 부서 목록 (GetDepLast)
 * - 그리드2: 공정 목록 (GetGonBasicR1) - No, 공정명, 공정코드 순
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 부서 목록 그리드 컬럼 (왼쪽)
 * GetDepLast 쿼리 응답: DepCd, DepNm1, DepNm2, DepNm3, DepNm4, DepNmLast, CustCd 등
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'right', 80, false, false, false, 'text', {
      maxWidth: 80,
    }),
    CreateColumn(
      'depNmLast',
      '부서',
      'left',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
  ];
};

/**
 * 공정 목록 그리드 컬럼 (오른쪽) - No, 공정명, 공정코드
 * - NO 컬럼: 행 선택 체크박스 (MEM_BASIC과 동일 구조, 삭제/복원/신규행 제거)
 * - 공정코드: 비활성화(신규 시 서버 채번)
 * - 공정명: 입력 가능 (저장 시 사용)
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼) - MEM_BASIC getColumnDefs1과 동일 구조
    CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
      suppressNavigable: true,
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow2,
        RestoreRow: props.RestoreRow2,
        gridRef: props.gridRef2,
        selectedRowNosRef: props.selectedRowNosRef2,
        lastCheckedIndexRef: props.lastCheckedIndexRef2,
        handleRowSelection: props.handleRowSelection2,
        preferNodeRowData: true,
      },
      maxWidth: 100,
    }),
    CreateColumn(
      'gongjongNm',
      '공정명',
      'left',
      200,
      true,
      false,
      false,
      'text',
      {
        minWidth: 200,
        flex: 1,
      }
    ),
    CreateColumn(
      'gongjongCd',
      '공정코드',
      'center',
      200,
      false,
      false,
      true,
      'text',
      {
        suppressNavigable: true,
        minWidth: 200,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
